
export const ViewPort = {
	Desktop: 'desktop',
	Tablet: 'tablet',
	Mobile: 'mobile'
};

export const Breakpoints = {
	Desktop: '992',
	Tablet: '750'
};

export const bootstrap = window.bootstrap = require('bootstrap');